import { useEffect, useMemo, useState } from "react";
import '../css/progress.css'
import Spacebox from "./Spacebox";

export default function ProgressWithStatuses({ onComplete }) {
  const MESSAGES = useMemo(
    () => [
      "Reviewing your qualified debt…",
      "Evaluating debt relief options…",
      "Analyzing potential savings…",
      "Confirming eligibility details…",
      "Preparing your results…",
      "Double-checking information for accuracy…",
      "Finalizing your relief summary…",
    ],
    []
  );

  const DURATION_MS = 60_000; // 60 seconds
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const start = Date.now();

    const tick = () => {
      const elapsed = Date.now() - start;
      const pct = Math.min(100, Math.round((elapsed / DURATION_MS) * 100));
      setProgress(pct);

      if (elapsed >= DURATION_MS) {
        clearInterval(timer);
        onComplete();
      }
    };

    tick(); // initial
    const timer = setInterval(tick, 100); // update every 100ms
    return () => clearInterval(timer);
    // eslint-disable-next-line
  }, []);

  const currentMessageIndex = Math.min(
    MESSAGES.length - 1,
    Math.floor((progress / 100) * MESSAGES.length)
  );
  const currentMessage = MESSAGES[currentMessageIndex];

  return (
    <div className="progress-wrap">
      <div style={{ width: 'fit-content' }} className="margin-auto">
        <img src="/assets/green-check.png" alt="check" style={{ width: 80 }} />
      </div>
      <Spacebox padding="10px" />
      <div className="progress">
        <div
          className="progress__bar"
          style={{ width: `${progress}%` }}
          aria-valuenow={progress}
          aria-valuemin={0}
          aria-valuemax={100}
          role="progressbar"
        />
        <span className={`progress__label ${progress > 50 ? 'text-white' : 'text-green'}`}>{progress}%</span>
      </div>

      <div className="status">{currentMessage}</div>
    </div>
  );
}
